const BASE_URL = `https://emails.arma.africa`

export const APIRoutes = {
    API: {
        EMAIL: `${BASE_URL}/contact`,
        FORM: `${BASE_URL}/form`
    }
}
